<template>
  <div class="nav">
    <div class="nav-title">
      <img class="first" src="../assets/icon/menu-black.svg" alt="">
      <span class="content">课程导航</span>
      <img class="last" src="../assets/icon/bottom-black.svg" alt="">
      <div class="nav-title-fixed">
        <ul>
        <li v-for="(item, index) in menuList" :key="index" :class="index === hoverindex ? 'active' : ''" @mouseover="hoverindex=index">
          <b>{{item.name}}</b>
          <div class="menufixed">
            <div class="menufixed-container" v-for="(itst,inst) in item.children" :key="inst+'00000'">
              <h6>{{itst.name}}</h6>
              <span v-for="(value,inin) in itst.children" :key="inin+'0000000'">{{value.name}}</span>
            </div>
          </div>
        </li>
      </ul>
      </div>
    </div>
    <ul class="nav-container">
      <li><a href="javascript:;" @click="goHref('/')">首页</a></li>
      <li><a href="javascript:;" @click="goHref('/classlist')">全部课程</a></li>
      <li><a href="javascript:;" @click="goHref('/company')">入驻机构</a></li>
      <li><a href="javascript:;" @click="goHref('/teacher')">合作讲师</a></li>
      <li><a href="javascript:;" @click="goHref('/come')">加盟入驻</a></li>
      <li><a href="javascript:;" @click="goHref('/examlist')">考试入口</a></li>
      <li><a href="javascript:;" @click="goHref('/book')">证书查询</a></li>
    </ul>
  </div>
</template>

<script>
import menuList from "@/assets/data/typeList.js";
export default {
  name: "Nav",
  data() {
    return {
      menuList,
      hoverindex: 0
    };
  },
  methods: {
    goHref(url) {
      this.$router.push(url)
    }
  }
};
</script>

<style lang="less" scoped>
.nav {
  width: 1300px;
  height: 22px;
  margin: 0 auto;
  padding: 9px 0 17px;
  text-align: right;
  position: relative;
  &-title {
    position: absolute;
    left: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      .nav-title-fixed {
        display: block;
      }
    }
    .first {
      width: 20px;
      height: 20px;
    }
    .last {
      width: 10px;
      height: 7px;
      margin-left: 10px;
    }
    .content {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 22px;
      margin-left: 8px;
    }
    &-fixed {
      position: absolute;
      left: 0;
      top: 20px;
      width: 1000px;
      height: 500px;
      border: 1px solid #eee;
      background: #fff;
      text-align: left;
      padding: 10px;
      box-sizing: border-box;
      display: none;
      z-index: 10;
    }
    ul {
      border-bottom: 1px solid #eee;
      height: 50px;
      li {
        display: inline-block;
        margin-right: 20px;
        line-height: 50px;
        height: 50px;
        cursor: pointer;
        box-sizing: border-box;
        &.active{
          border-bottom: 5px solid red;
          .menufixed {
            display: block;
          }
        }
      }
    }
    .menufixed {
      position: absolute;
      top: 60px;
      left: 10px;
      display: none;
        &-container {
          display: inline-block;
          vertical-align: top;
          width: 300px;
          margin-top: 20px;
          line-height: 24px;
          h6 {
            font-size: 14px;
          }
          span {
            color: #666666;
            font-size: 12px;
            display: inline-block;
            margin-right: 10px;
          }
        }
    }
  }
  &-container {
    display: inline-block;
    margin-right: 260px;
    li {
    display: inline-block;
    margin-left: 72px;
    a {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
  }
  }
}
</style>